import React from "react";
import { Button, ButtonProps } from "@mui/material";
import "../style/CustomButton.css";
import type { SxProps, Theme } from "@mui/material/styles";

export interface CustomButtonProps extends Omit<ButtonProps, "sx"> {
  customColor?: string;
  customFontSize?: string | number;
  customStyleVariant?: "default" | "glass";
  sx?: SxProps<Theme>;
}

export const CustomButton = ({
  customColor,
  customFontSize,
  customStyleVariant = "default",
  sx,
  className,
  ...props
}: CustomButtonProps) => {
  const rootClassName = [
    "custom-card-button",
    customStyleVariant !== "default"
      ? `custom-card-button--${customStyleVariant}`
      : "",
    className ?? "",
  ]
    .filter(Boolean)
    .join(" ");
  const customStyle: React.CSSProperties = {
    ...(customColor ? { color: customColor } : {}),
    ...(customFontSize ? { fontSize: customFontSize } : {}),
  };

  return <Button {...props} className={rootClassName} style={customStyle} sx={sx} />;
};